import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './InlineShell.scss'

class InlineShell extends React.Component {
	constructor(props) {
		super(props)
		const { width } = this.props

		let randomWidth = width
			? width * 0.7 + Math.floor(Math.random() * width * 0.7 + 1)
			: 70

		this.state = {
			randomWidth
		}
	}
	render() {
		return (
			<span
				styleName="inline"
				style={{ width: this.state.randomWidth }}
			/>
		)
	}
}

export default CSSModules(InlineShell, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Shells/InlineShell.js